import jQuery from "jquery"

window.$ = window.jQuery = jQuery

$(function() {
  setTimeout(function() {
    document.querySelectorAll('[data-disabled-button="true"]').forEach(el => {
      el.removeAttribute('disabled')
      el.classList.remove('disabled')
    })
  }, 500)
})